import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    AppBar, Button,
    Card,
    CardContent,
    Toolbar,
    Typography
} from '@material-ui/core';
import {withRouter} from "react-router-dom";
import ReduxCallHelper from "../../../../../store/actionreducers/callHelper";

const medical_level = {
    normal: {id: 1, label: 'normal', name: '一般', description: '一般醫師'},
    leader: {id: 2, label: 'leader', name: '總值班', description: '總值班醫師'},
    firefighter: {id: 3, label: 'firefighter', name: '救火隊', description: '救火隊醫師'},
    admin: {id: 4, label: 'admin', name: '管理部', description: '益友管理部醫師'},
    pharmacist: {id: 5, label: 'pharmacist', name: '藥師', description: '藥師'},
};

class ServiceInfoTab extends Component {

    state = {
        actionType: 'view', // view . add . edit
    };


    render() {
        const {actionType} = this.state;
        const {medical} = this.props;


        if (actionType === 'view') {

            const data = [
                {title: '職業', message:`${medical.job && medical.job.name} [接任務次序：${medical.level && medical.level.description}]` },
                {title: '科別', message: medical.division && medical.division.total_name},
                {title: '醫療機構', message: `${medical.city && medical.city.name} - ${medical.hospital && medical.hospital.name}`},
                {title: '狀態', message: medical.status && medical.status.name},
                {title: '益友編號', message: medical.no},
                {title: '醫事證號', message: medical.certificate_no},
                {title: '推薦人', message: medical.referrer}
            ];

            return (
                <div>
                    {/*<Typography className="font-bold mb-4 text-15">{'接任務順序'}</Typography>*/}
                    <div style={{padding:10, justifyContent: "space-between"}}>
                        <p>醫師接任務優先順序</p>
                        <Button
                            variant="raised"
                            color="default"
                            style={{marginRight: 10, marginTop: 10}}
                            onClick={async () => {
                                try {
                                    await this.props.setMedicalLevel({medicalId:medical.id, level: medical_level.normal});
                                } catch (e) {
                                    console.warn('you got an error = ', e);
                                }
                            }}
                        >
                            指定為一般醫師
                        </Button>
                        <Button
                            variant="raised"
                            color="secondary"
                            style={{marginRight: 10, marginTop: 10}}
                            onClick={async () => {
                                try {
                                    await this.props.setMedicalLevel({medicalId:medical.id, level: medical_level.leader});
                                } catch (e) {
                                    console.warn('you got an error = ', e);
                                }
                            }}
                        >
                            指定為總值醫師
                        </Button>
                        <Button
                            variant="raised"
                            color="primary"
                            style={{marginRight: 10, marginTop: 10}}
                            onClick={async () => {
                                try {
                                    await this.props.setMedicalLevel({medicalId:medical.id, level: medical_level.firefighter});
                                } catch (e) {
                                    console.warn('you got an error = ', e);
                                }
                            }}
                        >
                            指定為救火隊醫師
                        </Button>
                    </div>
                    <Card className="w-full mb-16">
                        <AppBar position="static" elevation={0}>
                            <Toolbar className="pl-16 pr-8">
                                <Typography variant="subheading" color="inherit" className="flex-1">
                                    服務設定
                                </Typography>
                            </Toolbar>
                        </AppBar>

                        <CardContent className="flex flex-col flex-wrap h-288">
                            {
                                data.map((dt, index) => (
                                    <div className="mb-16" key={`medical_info-${index}`}>
                                        <Typography className="font-bold mb-4 text-15">{dt.title}</Typography>
                                        <Typography>{dt.message ? dt.message : '無資料' }</Typography>
                                    </div>
                                ))
                            }
                        </CardContent>
                    </Card>
                </div>


            );
        } else {

            return (<div/>);
        }

    }

}



function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setMedicalLevel: ReduxCallHelper.ActionCreator.setMedicalLevel,
    }, dispatch);
}


function mapStateToProps({callHelper: {medical}}) {
    return {
        medical
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ServiceInfoTab));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/medical/tabs/ServiceInfoTab.js